import { isDefined } from "@omni/utils/helper.utils";
import { useEffect, useState } from "react";

import { useCheckout } from "@/components/Checkout/useCheckout.hook";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { CheckoutStepValidationResult } from "@/redux/modules/api/data/cart/@types/cart.types";
import { CheckoutSteps } from "@/utils/enums";

type CartCheckContainerProps = {
    checkoutStep: CheckoutSteps;
};

const CartCheckContainer = ({ checkoutStep }: CartCheckContainerProps) => {
    const { cartLoading, cart, validateCheckoutStep } = useCheckout();

    const [showSpinner, setShowSpinner] = useState(true);

    useEffect(() => {
        if (!showSpinner) return;

        if (cartLoading && !isDefined(cart)) return;

        validateCheckoutStep(checkoutStep, false).then((validationResult) => {
            if (validationResult === CheckoutStepValidationResult.Valid) {
                setShowSpinner(false);
            }
        });
    }, [checkoutStep, cart, cartLoading, validateCheckoutStep, showSpinner]);

    useEffect(() => {
        if (!showSpinner) return;

        document
            .querySelectorAll('[data-cart-check="true"]')
            .forEach((e) => e.setAttribute("data-cart-check", "false"));
    }, [showSpinner]);

    return showSpinner ? <Spinner /> : null;
};

export { CartCheckContainer };
